import React, { useEffect, useState } from "react";
import RatingStars from "./ratings-stars";
import RatingBook from "../ratingbook";
import { apiURL } from "../../helpers/url";

const formatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
});

function formatRatingAmount(amount) {
    return formatter.format(amount);
}

const openModal = () => {
    const ratingModal = document.getElementById("ratingModal");
    const overlay = document.getElementById("overlay");
    ratingModal.classList.remove("hidden");
    overlay.classList.remove("hidden");
};

const ProductRating = ({
    onClose,
    onRated,
    login, 
    rating, 
    ratingamount, 
    bookid, 
    onlystars, 
    onlytext, 
    notext, 
    onlyrating,
}) => {
    function handleClick() {
        openModal();
    }

    async function handleRating(data) {
        var response = await fetch(`${apiURL()}/rating/${bookid}`, {
            method: "POST",
            cache: "no-cache",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.head.querySelector("meta[name=csrf-token]").content,
            },
            referrerPolicy: "no-referrer",
            body: JSON.stringify(data),
        })
            .then((response) => {
                return response.text().then((text) => {
                    return {
                        status: response.status,
                        content: text,
                    };
                });
            })
            .then((response) => {
                let content = response.status < 300 ? JSON.parse(response.content) : null;

                return {
                    status: response.status,
                    content: content,
                };
            })
            .catch((error) => {
                this.promises.fetchSearch = null;
                return {
                    status: 600,
                    error: error,
                };
            });

        if (response.status !== 200) return;

        setRating(response.content.average);
        setRatingAmount(response.content.rateamount);
        onRated?.(response.content.average);
    }

    let [Rating, setRating] = useState(rating);
    let [RatingAmount, setRatingAmount] = useState(ratingamount);

    useEffect(() => {
        setRating(rating ?? Rating);
        setRatingAmount(ratingamount ?? RatingAmount);
    }, [rating, ratingamount]);

    if (onlyrating === "true") {
        return (
            <RatingBook
                bookid={bookid}
                login={login}
                totalRating={Rating}
                handleRating={handleRating}
            />
        );
    }

    if (onlystars === "true")
        return (
            <RatingStars size={20} rating={Rating} src="/images/icon/new-star-{value}.svg" />
        );

    return (
        <div className="d-flex align-items-center" style={{ gap: 10 }}>
            {(onlytext !== "true" && Rating != "undefined" && RatingAmount != "NaN") && (
                <>
                    <p
                        className="product-rating__overall m-0 pt-1"
                        style={{ color: "#1A1A1A", fontWeight: 600 }}
                    >
                        {Number(Rating).toFixed(1)}
                    </p>
                    <p className="m-0">({formatRatingAmount(RatingAmount)})</p>
                    <RatingStars
                        size={20}
                        rating={Rating}
                        src="/images/icon/new-star-{value}.svg"
                    />
                </>
            )}
            {/*<div className={className} id="edit-rating" onClick={handleClick}>*/}
            {/*    <span>({RatingAmount})</span>*/}
            {/*    <img src="/images/icon/pen.svg" alt="Pen" />*/}
            {/*</div>*/}

            {notext !== "true" && (
                <button
                    className={`${
                        onlytext === "true" ? "p-0" : "m-0 ml-2 pt-1"
                    } border-0 bg-transparent`}
                    id="edit-rating"
                    style={{ textDecoration: "underline", color: "#1A1A1A", outline: "none" }}
                    onClick={handleClick}
                >
                    Vélemény írása
                </button>
            )}

            <RatingBook
                bookid={bookid}
                login={login}
                totalRating={Rating}
                handleRating={handleRating}
                onClose={onClose}
            />
        </div>
    );
};

export default ProductRating;
